import React from "react";
import SvgIcon from "../components/UI/SVGIcon";
import { isTelegramWebApp } from "./platform";

const isNumber = (char) => {
    return /^\d$/.test(char);
}

const classN = "exp-filters";

const top5TokensNameWidth = () => {
    let width = 250;
    if(window.innerWidth < 480) {  
        width = 'auto';
    }
    return width;
}

const cryptogroupImgtWidth = () => {
    let width = 250;
    if(window.innerWidth < 900) {  
        width = 170;
    }
    const isTgr = isTelegramWebApp();
    if(isTgr) {
        width = 'auto';
    }
    return width;
}

const tokenNameWidth = () => {
    let width = 250;
    if(window.innerWidth < 900) {  
        width = 170;
    }
    return width;
}

const addToWatchListtWidth = () => {
    let width = 60;
    if(window.innerWidth < 900) {  
        width = 40;
    }
    return width;
}

const customSort = (valueA, valueB, nodeA, nodeB, isDescending) => {
    if(valueA && valueB) {
        // check for emojis and remove them
        const emojiRegex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi;
        const aStr = String(valueA).replace(emojiRegex, '');
        const bStr = String(valueB).replace(emojiRegex, '');
        // First: check the values at the end of the string for char like % or k... etc. and remove it
        const lastvalueACharIsNotNumber = !isNumber(valueA[valueA.length - 1]);
        const lastvalueBCharIsNotNumber = !isNumber(valueB[valueB.length - 1]);

        let a = aStr;
        //console.log(valueA.charAt(valueA.length - 1))
        //console.log(isNumber(valueA[valueA.length - 1]))
        let b = bStr;
        if(a === 'N/A') {
            return -1
        }
        if(b === 'N/A') {   
            return 1;
        }
        // remove the last char if is not integer
        if(lastvalueACharIsNotNumber) {
            a = a.slice(0, -1);
        }
        if(lastvalueBCharIsNotNumber) {
            b = b.slice(0, -1);
        }
        // remove '+' at the begining
        if(a.charAt(0) === '+') {
            a = a.slice(1);
        }
        let aNum = parseFloat(a);
        if(b.charAt(0) === '+') {
            b = b.slice(1);
        }
        let bNum = parseFloat(b);
        if (aNum === bNum) return 0;
        else if (aNum === null)  // a is null? last 
        return 1;
        else if (bNum === null)  // b is null? last
        return -1;
        // compare formatted numbers such as "14.5K", "2.65M"... or numbers such as "14.5K%", "2.65M%"
        const isFormattedNumString = (valueA[valueA.length - 1] === 'K' || valueA[valueA.length - 1] === 'M' || valueA[valueA.length - 1] === 'B') ||
                                    (valueB[valueB.length - 1] === 'K' || valueB[valueB.length - 1] === 'M' || valueB[valueB.length - 1] === 'B') ||
                                    (a[a.length - 1] === 'K' || a[a.length - 1] === 'M') ||  
                                    (b[b.length - 1] === 'K' || b[b.length - 1] === 'M');
        if(isFormattedNumString) {
            if(valueA[valueA.length - 1] === 'K' || valueA[valueA.length - 2] === 'K') {
                aNum = aNum * 1000;
            }
            if(valueB[valueB.length - 1] === 'K' || valueB[valueB.length - 2] === 'K') {
                bNum = bNum * 1000;
            }
            if(valueA[valueA.length - 1] === 'M' || valueA[valueA.length - 2] === 'M') {
                aNum = aNum * 1000000;
            }
            if(valueB[valueB.length - 1] === 'M' || valueB[valueB.length - 2] === 'M') {
                bNum = bNum * 1000000;
            }
            if(valueA[valueA.length - 1] === 'B') {
                aNum = aNum * 1000000000;
            }
            if(valueB[valueB.length - 1] === 'B') {
                bNum = bNum * 1000000000;
            }
            //return aNum.toString().localeCompare(bNum.toString()) > 0 ? 1: -1;
        }

        return (aNum > bNum) ? 1 : -1;
    }
    
}

const CallEfHtml = (props) => {
    //AVG_TracingImpact
    let callVal = props.data.AVG_CallImmediateEffect;
    if(typeof(callVal) === 'string') {
        let sliced = callVal.slice(0, callVal.length - 1);
        sliced = parseFloat(sliced);
        //traceVal = sliced;
    }
    return (
        <span>{callVal}</span>
    )
}

const BuyLinkHtml = (props) => {
    return (
        <div>
            {props !== undefined ? (
                <div className="flex-box custom-cell buyLinkFlozz">
                    <div className="ellipsis accent-txt1" style={{'cursor': 'pointer'}}>
                        {/* <a className="ellipsis accent-txt1" href={props.data.BuyLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer">{props.data.BuyLink}</a> */}
                        <a className="ellipsis" href={props.data.BuyLinkFlozz} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer"></a>
                    </div>
                    {/* <div title="Copy Link"><SvgIcon copyText={props.data.BuyLink} /></div> */}
                </div>
            ) : null}
        </div>
    )
}

const TracingImpactHtml = (props) => {
    const label = props.data.SuccessRate;
    let txtColor;
    if(label) {
        txtColor = label[0] === '-' ? 'red-value-label' : 'green-value-label';
    }
    else {
        txtColor = '';
    }
    
    return (
        <div className="custom-cell totalmcap-cell sgt-cell info-icon-cell">
            {props !== undefined ? (
                <>
                    <span className="info-icon"></span>
                    <p className={txtColor}>{props.data.SuccessRate}</p>
                    <p className="inter-medium-16 gray-txt" style={{"fontSize": "12px"}}>TRACE</p>
                </>
            ) : null}
        </div>
    )
}

const TwitterLinkHtml = (props) => {
    return (
        <div>
            {props !== undefined ? (
                <div className="flex-box custom-cell twitter-link">
                    <div className="ellipsis accent-txt1" style={{'cursor': 'pointer'}}>
                        {/* <a className="ellipsis accent-txt1" href={props.data.BuyLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer">{props.data.BuyLink}</a> */}
                        <a className="ellipsis" href={props.data.TwitterLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer"></a>
                    </div>
                    {/* <div title="Copy Link"><SvgIcon copyText={props.data.BuyLink} /></div> */}
                </div>
            ) : null}
        </div>
    )
}

const GroupLinkHtml = (props) => {
    const href = props.data.NameOfCallGroup ? `/tokens/${props.data.NameOfCallGroup}` : '';
    return (
        <div>
            {props !== undefined && props.data.NameOfCallGroup ? (
                <div className="flex-box custom-cell group-link">
                    <div className="ellipsis accent-txt1" style={{'cursor': 'pointer'}}>
                        {/* <a className="ellipsis accent-txt1" href={props.data.BuyLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer">{props.data.BuyLink}</a> */}
                        <a className="ellipsis" href={href} style={{'textDecoration': 'none'}} rel="noreferrer"></a>
                    </div>
                    {/* <div title="Copy Link"><SvgIcon copyText={props.data.BuyLink} /></div> */}
                </div>
            ) : null}
        </div>
    )
}

const TelegramLinkHtml = (props) => {
    return (
        <div>
            {props !== undefined ? (
                <div className="flex-box custom-cell telegram-link">
                    <div className="ellipsis accent-txt1" style={{'cursor': 'pointer'}}>
                        {/* <a className="ellipsis accent-txt1" href={props.data.BuyLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer">{props.data.BuyLink}</a> */}
                        <a className="ellipsis" href={props.data.TelegramLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer"></a>
                    </div>
                    {/* <div title="Copy Link"><SvgIcon copyText={props.data.BuyLink} /></div> */}
                </div>
            ) : null}
        </div>
    )
}

const RedOrGreenColoringHtml = (props) => {
    const label = props.data.AVG_TracingImpact;
    let txtColor;
    if(label) {
        txtColor = label[0] === '-' ? 'red-value-label' : 'green-value-label';
    }
    else {
        txtColor = '';
    }
    return (
        <div>
            {props !== undefined ? (
                <div className={txtColor}>{props.data.AVG_TracingImpact}</div>
            ) : null}
        </div>
    )
}


const RedOrGreenColoringPeak = (props) => {
    const label = props.data.AVG_FromCallToPeak;
    let txtColor;
    if(label) {
        txtColor = label[0] === '-' ? 'red-value-label' : 'green-value-label';
    }
    else {
        txtColor = '';
    }
    return (
        <div className="custom-cell sgt-cell">
            {props !== undefined ? (
                <>
                    <div className={txtColor}>{props.data.AVG_FromCallToPeak}</div>
                    <p className="inter-medium-16 gray-txt" style={{"fontSize": "12px"}}>PEAK</p>
                </>
            ) : null}
        </div>
    )
}

const FromCalltoPeakHTML = (props) => {
    const label = props.data.FromCalltoPeak  ? props.data.FromCalltoPeak : "";
    const txtColor = label[0] === '-' ? 'red-value-label' : 'green-value-label';
    return (
        <div className="custom-cell sgt-cell info-icon-cell">
            {props !== undefined && props.data.FromCalltoPeak ? (
                <>
                    <span className="info-icon"></span>
                    <p className={txtColor}>{props.data.FromCalltoPeak}</p>
                    <p className="inter-medium-16 gray-txt" style={{"fontSize": "12px"}}>PEAK</p>
                </>
            ) : null}
        </div>
    )
}

const RedOrGreenColoringCallEf = (props) => {
    // make sure we always have a string to index
    const raw = props && props.data && props.data.AVG_CallImmediateEffect;
    const label = (typeof raw === 'undefined' || raw === null) ? '' : String(raw);
    const txtColor = label && label[0] === '-' ? 'red-value-label' : 'green-value-label';
    return (
        <div className={txtColor}>{label}</div>
    )
}


const TokenContractHtml = (props) => {
    return (
        <div>
            {props !== undefined ? (
                <div className="flex-box custom-cell scanLink">
                    <div className="ellipsis accent-txt1" style={{'cursor': 'pointer'}}>
                        {/* <a className="ellipsis accent-txt1" href={props.data.BuyLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer">{props.data.BuyLink}</a> */}
                        <a className="ellipsis" href={props.data.ScanLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer"></a>
                    </div>
                    {/* <div title="Copy Link"><SvgIcon copyText={props.data.BuyLink} /></div> */}
                </div>
            ) : null}
        </div>
    )
}

const addToWatchListBtn = (props) => {
    const wList = localStorage.getItem('watchlist');
    let added = '';
    if(wList) {
        const name = props.data.NameOfCallGroup;
        const list = JSON.parse(wList);
        const filtered = list.filter((el) => el.nameOfCallGroup === name);
        const isAdded = filtered.length > 0;
        if(isAdded) {
            added = 'added';
        }
    }
    return (
        <div className="add-to">
            <span className={`add-to-watchlist ${added}`}></span>
        </div>
    )
}

const CallGroupImageHtml = (props) => {
    let imageBase64str;
    const folderName = '/callgrimages/';
    let imgUrl = '';
    if(props.data.CryptoGroupImage || props.data.Image || props.data.TokenImage) {
        let imgSrc = props.data.CryptoGroupImage || props.data.Image || props.data.TokenImage;
        imageBase64str = imgSrc.replace(/(\r\n|\n|\r)/gm, "");
        if(imageBase64str && imageBase64str !== '' && !imageBase64str.startsWith('http')) {
            imageBase64str = "data:image/png;base64, " + imgSrc.replace(/(\r\n|\n|\r)/gm, "");
        }
        if(imageBase64str.startsWith('http')) {
            imageBase64str = imgSrc;
        }
        if(imgSrc === null || imageBase64str.startsWith('https://shillguard-001')) {
            // TOP 5 Callers
            const imgName = imgSrc.split('/').pop();
            const img = folderName + imgName;
            imageBase64str = img;
        }
    }
    
    return (
        <div>
            {props !== undefined ? (
                <div className={props.CryptoGroupImage ? 'flex-box custom-cell rounded-img' : 'custom-cell rounded-img'} >
                    {imageBase64str? (
                        <img height={36} src={imageBase64str} alt="CallGroupImage" />
                    ) : null}
                    {/* {props.data.Image ? (<img height={27} src={props.data.Image} alt="CallGroupImage" />) : null} */}
                </div>
            ) : null}
        </div>
    )
}

const addDefaultSrc = (e) =>{
    return e.target.src = '/img/no-image.png'
}

const CallGroupImageWithHeaderHtml = (props) => {
    let imageBase64str;
    const folderName = '/callgrimages/';
    let imgUrl = '';
    if(props.data.CryptoGroupImage || props.data.Image || props.data.TokenImage) {
        let imgSrc = props.data.CryptoGroupImage || props.data.Image || props.data.TokenImage;
        imageBase64str = imgSrc.replace(/(\r\n|\n|\r)/gm, "");
        if(imageBase64str && imageBase64str !== '' && !imageBase64str.startsWith('http')) {
            imageBase64str = "data:image/png;base64, " + imgSrc.replace(/(\r\n|\n|\r)/gm, "");
        }
        if(imageBase64str.startsWith('http')) {
            imageBase64str = imgSrc;
        }
        if(imgSrc === null || imageBase64str.startsWith('https://shillguard-001')) {
            // TOP 5 Callers
            const imgName = imgSrc.split('/').pop();
            const img = folderName + imgName;
            imageBase64str = img;
        }
    }
    
    return (
        <div className="callGroupname">
            {props !== undefined ? (
                <div className={props.CryptoGroupImage ? 'flex-box custom-cell rounded-img' : 'custom-cell rounded-img'} >
                    {imageBase64str? (
                        <div className="ellipsis image-name flex-box">
                                <div>
                                    <img onError={addDefaultSrc} height={36} src={imageBase64str} alt="CallGrImg" />
                                </div>
                                <div className="sgt-cell" style={{"flex": "1"}}>
                                    <p><span className="ellipsis blue-txt inter-bold-16">{props.data.NameOfCallGroup}</span></p>
                                    <p className="inter-medium-16 gray-txt" style={{"fontSize": "12px"}}>CALL GROUP</p>
                                </div>
                            </div>
                    ) : null}
                    {/* {props.data.Image ? (<img height={27} src={props.data.Image} alt="CallGroupImage" />) : null} */}
                </div>
            ) : null}
        </div>
    )
}

const TokenSymbolHtml = (props) => {
    return (
        <div className="callGroupname">
            {props !== undefined ? (
                <div className={props.CryptoGroupImage ? 'flex-box custom-cell rounded-img' : 'custom-cell rounded-img'} >
                    {props.data.TokenSymbol? (
                        <div className="ellipsis image-name flex-box">
                                <div>
                                    <img onError={addDefaultSrc} height={36} src={props.data.TokenImage} alt="CallGrImg" />
                                </div>
                                <div className="sgt-cell" style={{"flex": "1"}}>
                                    <p><span className="ellipsis inter-bold-16">{props.data.TokenSymbol}</span></p>
                                    <p className="inter-medium-16 gray-txt" style={{"fontSize": "12px"}}>TOKEN</p>
                                </div>
                            </div>
                    ) : null}
                    {/* {props.data.Image ? (<img height={27} src={props.data.Image} alt="CallGroupImage" />) : null} */}
                </div>
            ) : null}
        </div>
    )
}

const FullTokenSymbolHtml = (props) => {
    return (
        <div className="custom-cell"><div className="ellipsis">{props.data.TokenName}</div></div>
    )
}

const top5NumberLabel = (data) => {
    return `#${data.node.rowIndex + 1}`;
}

const TOP5CallersName = (props) => {
    return props.data.Name;
}

const TOP5TokensAndVisitedName = (props) => {
    return (
        <div className="top-grid-name">{props.data.Name}</div>
    );
}

const BuyLinkCalls = (props) => {
    return (
        <div>
            {props !== undefined ? (
                <div className="flex-box custom-cell chartLink">
                    <div className="ellipsis accent-txt1" style={{'cursor': 'pointer'}}>
                        {/* <a className="ellipsis accent-txt1" href={props.data.BuyLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer">{props.data.BuyLink}</a> */}
                        <a className="ellipsis" href={props.data.BuyLink} style={{'textDecoration': 'none'}} target="_blank" rel="noreferrer"></a>
                    </div>
                    {/* <div title="Copy Link"><SvgIcon copyText={props.data.BuyLink} /></div> */}
                </div>
            ) : null}
        </div>
    )
}

const ToggleFilters = (props) => {
    const toggle = () => {
        const parentEl = document.querySelector('#root');
        if(parentEl) {
            if(parentEl.className.indexOf('exp-filters') === -1) {
                parentEl.classList.add('exp-filters');
            }
            else {
                parentEl.classList.remove('exp-filters');
            }
        }
    }
    return (
        <div>
            <button onClick={toggle}>Show filters</button>
        </div>
    )
}

const toggleFilters = () => {
    console.log(1234)
    const parentEl = document.querySelector('#root');
        if(parentEl) {
            if(parentEl.className.indexOf('exp-filters') === -1) {
                parentEl.classList.add('exp-filters');
            }
            else {
                parentEl.classList.remove('exp-filters');
            }
        }
}

function dateComparator(date1, date2) {
    if(date1 !== undefined && date2 !== undefined) {
        date1 = date1.replace(/\s+/g,'T');
        date2 = date2.replace(/\s+/g,'T');
        const dt1 = date1.split('T');
        date1 = dt1[0].split("-").reverse().join("-");
        date1 += 'T' + dt1[1];
        const dt2 = date2.split('T');
        date2 = dt2[0].split("-").reverse().join("-");
        date2 += 'T' + dt2[1];
        const d1 = Date.parse(date1);
        const d2 = Date.parse(date2);
        return d1 - d2;
    }
    else{
        return -1;
    }
}

const FormatDateAndTime = (props) => {
        // 2025-09-14T22:05:45
        let date = '';
        const str = props.dateString ? props.dateString.replace(' ', 'T') : '';
        let d = new Date(str);
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = d.getDate();
        const formatedDay = day < 10 ? '0' + day : day;
        //const month = d.getMonth() + 1;
        let year = d.getFullYear();
        year = year.toString().slice(2, year.length);
        date = formatedDay + ' ' + monthNames[d.getMonth()] + ' ' + year;
        // "12.01.24"
        let h = d.getHours();
        let hours = h < 10 ? '0' + h : h;
        let minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
        //let minutes = d.getMinutes();
        let s = d.getSeconds();
        let seconds = s < 10 ? '0' + s : s;
        if(isTelegramWebApp()) {
            return (
                <div>
                    <p>{date} {hours}:{minutes}:{seconds}</p>
                </div>
            );
        }
        return (
            <div>
                <p>{date}</p>
                <p>{hours}:{minutes}:{seconds}</p>
            </div>
        );
    }

export const formatDateTimeStr = (dt) => {
    let date = '';
    const str = dt ? dt.replace(' ', 'T') : '';
    let d = new Date(str);
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = d.getDate();
    const formatedDay = day < 10 ? '0' + day : day;
    //const month = d.getMonth() + 1;
    let year = d.getFullYear();
    //year = year.toString().slice(2, year.length);
    date = formatedDay + ' ' + monthNames[d.getMonth()] + ' ' + year;
    // "12.01.24"
    let h = d.getHours();
    let hours = h < 10 ? '0' + h : h;
    let minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
    //let minutes = d.getMinutes();
    let s = d.getSeconds();
    let seconds = s < 10 ? '0' + s : s;
    const result = date + " " + hours + ":" + minutes + ":" + seconds;
    return result;
}

const TimeStampHTML = (props) => {
    return (
        <div>
            {props !== undefined ? (
                <div className="flex-box custom-cell timestamp-cell">
                    <FormatDateAndTime dateString={props.data.Timestamp} />
                    {/* <div title="Copy Link"><SvgIcon copyText={props.data.BuyLink} /></div> */}
                </div>
            ) : null}
        </div>
    )
}

const ChainHTML = (props) => {
    return (
        <div>
            {props !== undefined && props.data.Chain ? (
                <div className="custom-cell network-cell">
                    <p>{props.data.Chain}</p>
                    {isTelegramWebApp() ? null : (
                        <p className="inter-medium-16 gray-txt" style={{"fontSize": "12px"}}>NETWORK</p>
                    )}
                </div>
            ) : null}
        </div>
    )
}

const PriceHTML = (props) => {
    return (
        <div>
            {props !== undefined && props.data.PriceUSD ? (
                // <div className="custom-cell network-cell price-cell">
                <div className="custom-cell sgt-cell info-icon-cell">
                    <span className="info-icon"></span>
                    <p>${props.data.PriceUSD}</p>
                    <p className="inter-medium-16 gray-txt" style={{"fontSize": "12px"}}>PRICE</p>
                </div>
            ) : null}
        </div>
    )
}

const TotalMarketCapINHTML = (props) => {
    return (
        <div>
            {props !== undefined && props.data.TotalMarketCapIN ? (
                <div className="custom-cell totalmcap-cell sgt-cell info-icon-cell">
                    <span className="info-icon"></span>
                    <p>${props.data.TotalMarketCapIN}</p>
                    <p className="inter-medium-16 gray-txt" style={{"fontSize": "12px"}}>CALL M.CAP</p>
                </div>
            ) : null}
        </div>
    )
}

const TotalMarketCapHTML = (props) => {
    return (
        <div>
            {props !== undefined && props.data.TotalMarketCap ? (
                <div className="custom-cell totalmcap-cell sgt-cell info-icon-cell">
                    <span className="info-icon"></span>
                    <p>${props.data.TotalMarketCap}</p>
                    <p className="inter-medium-16 gray-txt" style={{"fontSize": "12px"}}>M.CAP</p>
                </div>
            ) : null}
        </div>
    )
}

const ImpactOfCallHTML = (props) => {
    const raw = props && props.data && props.data.ImpactOfCall;
    const label = (typeof raw === 'undefined' || raw === null) ? '' : String(raw);
    const txtColor = label && label[0] === '-' ? 'red-value-label' : 'green-value-label';
    return (
        <div>
            {props !== undefined ? (
                
                <div className="custom-cell totalmcap-cell sgt-cell info-icon-cell">
                    <span className="info-icon"></span>
                    <p className={txtColor}>{label}</p>
                    <p className="inter-medium-16 gray-txt" style={{"fontSize": "12px"}}>CALL EFC</p>
                </div>
            ) : null}
        </div>
    )
}

const VolumeGenereted_h24HTML  = (props) => {
    return (
        <div>
            {props !== undefined && props.data.VolumeGenereted_h24 ? (
                <div className="custom-cell totalmcap-cell sgt-cell info-icon-cell">
                    <span className="info-icon"></span>
                    <p>${props.data.VolumeGenereted_h24}</p>
                    <p className="inter-medium-16 gray-txt" style={{"fontSize": "12px"}}>VOLUME (24h)</p>
                </div>
            ) : null}
        </div>
    )
}

const LiquidityHTML = (props) => {
    return (
        <div>
            {props !== undefined && props.data.Liquidity ? (
                <div className="custom-cell totalmcap-cell sgt-cell info-icon-cell">
                    <span className="info-icon"></span>
                    <p>${props.data.Liquidity}</p>
                    <p className="inter-medium-16 gray-txt" style={{"fontSize": "12px"}}>LIQUIDITY</p>
                </div>
            ) : null}
        </div>
    )
}

const Top5VisitedMarketCapHTML = (props) => {
    return (
        <>
            {props !== undefined && props.data.MarketCap ? (
                <>{props.data.MarketCap}</>
            ) : null}
        </>
    )
}

export const gridColumns = [
    
    // Home Page
    // Common columns:
    {
        field: 'NameOfCallGroup', 
        headerName: 'Call Group', 
        resizable: true,
        headerClass: 'i-icon',
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        headerTooltip: 'The name of the group or individual influencer responsible for making the call.',
    },
    // Token Details page
    // Common columns:
    {field: 'number', valueGetter: "node.rowIndex + 1", headerName: "#", width: 60, sortable: false, suppressSorting: true},
    {
        field: 'Top5TokensImage', 
        headerName: 'Call Group', 
        resizable: true,
        width: 50,
        headerClass: 'i-icon',
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        headerTooltip: 'The image of the cryptocurrency token.',
        comparator: customSort,
        cellRenderer: CallGroupImageHtml,
    },
    {
        field: 'CryptoGroupImage', 
        headerName: 'Call Group', 
        resizable: true,
        width: cryptogroupImgtWidth(),
        headerClass: 'i-icon',
        valueGetter: (p) => p.data.NameOfCallGroup,
        headerTooltip: 'The image of the group or individual influencer responsible for making the call.',
        cellRenderer: CallGroupImageWithHeaderHtml,
        
    },
    {
        field: 'TokenName', 
        headerName: 'Token', 
        resizable: true,
        width: tokenNameWidth(),
        headerClass: 'i-icon',
        valueGetter: (p) => p.data.TokenSymbol,
        headerTooltip: 'The Token symbol of the cryptocurrency token being called last.',
        cellRenderer: TokenSymbolHtml,
        
    },
    {
        field: 'AddToWatchList', 
        headerName: '', 
        resizable: true,
        width: addToWatchListtWidth(),
        headerClass: 'i-icon',
        headerTooltip: '',
        cellRenderer: addToWatchListBtn,
        
    },
    {
        field: 'FullTokenName', 
        headerName: 'Token Name', 
        resizable: true,
        headerClass: 'i-icon',
        width: 140,
        tooltipValueGetter: (p) => p.data.TokenName,
        valueGetter: (p) => p.data.TokenName,
        headerTooltip: 'The name of the cryptocurrency token being called last.',
        cellRenderer: FullTokenSymbolHtml,
        
    },
    {
        field: 'CallsFullTokenName', 
        headerName: 'FullTokenName', 
        resizable: true,
        headerClass: 'i-icon',
        width: 220,
        tooltipValueGetter: (p) => p.data.TokenName,
        headerTooltip: 'The name of the cryptocurrency token being called last.',
        cellRenderer: FullTokenSymbolHtml,
        
    },
    //OrderNumber
    {
        field: 'OrderNumber', 
        headerName: 'OrderNumber', 
        resizable: true,
        headerClass: 'i-icon',
        headerTooltip: 'The name of the cryptocurrency token being called last.',
        
    },
    {
        field: 'BuyLink', 
        headerName: '', 
        resizable: true, 
        width: 60,
        enableCellTextSelection: true,
        headerTooltip: 'A link to a platform where users can purchase the mentioned token.',
        headerClass: 'buyHeader',
        cellRenderer: BuyLinkHtml,
        
    },
    {
        field: 'TotalMarketCapIN', 
        headerName: 'CALL M.CAP', 
        resizable: true,
        width: 130,
        headerClass: 'i-icon',
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        valueGetter: (params) => params.data.TotalMarketCapIN,
        headerTooltip: 'The market capitalization of the token at the time of the call.',
        cellRenderer: TotalMarketCapINHTML,
        comparator: customSort,
        
    },
    {
        field: 'TotalMarketCap', 
        headerName: 'MktCap', 
        resizable: true, 
        width: 110,
        headerClass: 'i-icon',
        cellRenderer: TotalMarketCapHTML,
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        headerTooltip: 'The current market capitalization of the token.' ,
        comparator: customSort
    },
    {
        field: 'Liquidity',
        headerName: 'Liquidity', 
        resizable: true, 
        width: 110,
        headerClass: 'i-icon',
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        headerTooltip: 'The current Liquidity.' ,
        cellRenderer: LiquidityHTML,
        comparator: customSort,
    },
    {
        field: 'MarketCap', 
        headerName: 'MktCap', 
        resizable: true, 
        width: 80,
        headerClass: 'i-icon',
        headerTooltip: 'The current market capitalization of the token.' ,
        comparator: customSort
    },
    {
        field: 'Top_Visited_MarketCap', 
        headerName: 'M.CAP', 
        resizable: true, 
        width: 120,
        headerClass: 'i-icon',
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        headerTooltip: 'The current market capitalization of the token.' ,
        valueGetter: (params) => params.data.MarketCap,
        comparator: customSort,
        cellRenderer: Top5VisitedMarketCapHTML
    },
    {
        field: 'ImpactOfCall', 
        headerName: 'CALL EFC', 
        resizable: true, 
        width: isTelegramWebApp() ? 115 : 110,
        headerClass: 'i-icon',
        cellRenderer: ImpactOfCallHTML,
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        headerTooltip: 'Maximal positive  market capitalization change  of the token in the first 15 minutes after the call was made.' ,
        comparator: customSort
    },
    {
        field: 'SuccessRate', 
        headerName: 'Trace', 
        resizable: true,
        width: isTelegramWebApp() ? 115 : 125,
        headerClass: 'i-icon',
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        headerTooltip: "An ongoing assessment of the token's market capitalization movement and impact since the call.",
        cellRenderer: TracingImpactHtml,
        comparator: customSort
    },
    {
        field: 'FromCalltoPeak', 
        headerName: 'Peak',
        resizable: true,
        width: isTelegramWebApp() ? 115 : 130,
        headerClass: 'i-icon',
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        cellRenderer: FromCalltoPeakHTML,
        headerTooltip: "The percentage change in price from the time of the call to the token's all-time high (ATH).",
        comparator: customSort
    },
    {
        field: 'TwitterLink', 
        headerName: '',
        resizable: true,
        width: 60,
        headerClass: 'twitter-link',
        headerTooltip: "",
        cellRenderer: TwitterLinkHtml,
        comparator: customSort
    },
    {
        field: 'GroupLink', 
        headerName: '',
        resizable: true,
        width: 60,
        headerClass: 'group-link',
        headerTooltip: "",
        cellRenderer: GroupLinkHtml,
        comparator: customSort
    },
    {
        field: 'TelegramLink', 
        headerName: '',
        resizable: true,
        width: 60,
        headerClass: 'twitter-link',
        headerTooltip: "",
        cellRenderer: TelegramLinkHtml,
        comparator: customSort
    },
    // Extra Columns:
    {
        field: 'TokenHash', 
        headerName: '', 
        resizable: true,
        width: 60,
        headerTooltip: "The unique cryptographic identifier associated with the token on the blockchain.",
        headerClass: 'caHeader',
        cellRenderer: TokenContractHtml,
    },
    {
        field: 'BuyLinkCalls', 
        headerName: '', 
        resizable: true,
        width: 60,
        headerTooltip: "The unique cryptographic identifier associated with the token on the blockchain.",
        headerClass: 'chartHeader',
        cellRenderer: BuyLinkCalls,
    },
    {
        field: 'Chain', 
        headerName: 'NETWORK', 
        width: 100,
        resizable: true,
        headerClass: 'i-icon',
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        cellRenderer: ChainHTML,
        headerTooltip: "Chain The blockchain on which the cryptocurrency token operates."
    },
    {
        field: 'PriceUSD', 
        headerName: 'Price', 
        resizable: true,
        // headerClass: 'priceHeader i-icon',
        headerClass: 'i-icon',
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        cellRenderer: PriceHTML,
        headerTooltip: "Current price of the token in USD.",
    },
    {
        field: 'VolumeGenereted_h24', 
        headerName: 'Volume(24)', 
        width: 140,
        resizable: true,
        headerClass: 'i-icon',
        cellRenderer: VolumeGenereted_h24HTML,
        valueGetter: (params) => params.data.VolumeGenereted_h24,
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        comparator: customSort,
        headerTooltip: "The trading volume of the token.",
    },
    {
        field: 'Volume', 
        headerName: 'Volume', 
        width: 100,
        resizable: true,
        headerClass: 'i-icon',
        valueGetter: (params) => params.data.Volume,
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        headerTooltip: "The trading volume of the token.",
        comparator: customSort,
    },
    {
        field: 'ToggleFilters', 
        headerName: ' ', 
        resizable: true,
        width: 110,
        headerTooltip: "",
        headerClass: 'toggle-filters-column',
        // headerComponentParams: {
        //     template:
        //         '<div class="ag-cell-label-container" role="presentation" onclick=" ' +
        //         'const parentEl = document.body; ' +
        //         'if(parentEl) { ' +
        //         'if(parentEl.className.indexOf("'+ classN +'") === -1) { ' +
        //             ' parentEl.classList.add("'+ classN +'"); ' +
        //                 '} ' +
        //             ' else { ' +
        //             'parentEl.classList.remove("'+ classN +'"); ' +
        //                 '} ' +
        //             '} ' +
        //         ' ">Toggle filters' +
        //     '</div>'
        // },
    },
    // {field: 'ATX', headerName: 'ATX', resizable: true },
    {
        field: 'Holders', 
        headerName: 'Holders', 
        resizable: true,
        headerClass: 'i-icon',
        headerTooltip: "The number of token holders or addresses holding the cryptocurrency.",
    },
    {
        field: 'CryptoTokenCall', 
        headerName: 'Call Description', 
        resizable: true,
        headerClass: 'i-icon',
        headerTooltip: "Contains the text or description of the cryptocurrency call made by the group or influencer.",
        tooltipField: 'CryptoTokenCall',
    },
    {
        field: 'Source', 
        headerName: 'Source', 
        resizable: true,
        headerClass: 'i-icon',
        headerTooltip: "Platform or channel from which the cryptocurrency call or recommendation originated.",
        // headerComponentParams: {
        //     template: infoHeaderTemplate()
        // }
    },
    {
        field: 'Timestamp', 
        headerName: 'Date', 
        resizable: true,
        width: 140,
        tooltipValueGetter: (p) => formatDateTimeStr(p.value),
        headerClass: 'i-icon',
        headerTooltip: "Day/Month/Year/UTC time of the call.",
        cellRenderer: TimeStampHTML,
    },
    {field: 'Top5Number', valueGetter: top5NumberLabel, headerName: "#", width: 40, sortable: false, suppressSorting: true},
    {
        field: 'Image', 
        headerName: 'Image', 
        resizable: true,
        width: 50,
        headerClass: 'i-icon',
        headerTooltip: 'The image of the group or individual influencer responsible for making the call.',
        cellRenderer: CallGroupImageHtml,
    },
    {
        field: 'Name', 
        headerName: 'Name', 
        resizable: true,
        width: 100,
        headerClass: 'i-icon',
        headerTooltip: 'The name of the cryptocurrency token being called last.',
    },
    {
        field: 'TOP5TokensName', 
        headerName: 'Name', 
        resizable: true,
        width: top5TokensNameWidth(),
        headerClass: 'i-icon',
        cellRenderer: TOP5TokensAndVisitedName,
        valueGetter: (params) => params.data.Name,
        flex: 1,
        headerTooltip: 'The name of the cryptocurrency token being called last.',
    },
    {
        field: 'TOP5CallersName', 
        headerName: 'Name', 
        resizable: true,
        width: 160,
        headerClass: 'i-icon',
        valueGetter: (params) => params.data.Name,
        headerTooltip: 'The name of the cryptocurrency caller being called last.',
        flex: 1,
        cellRenderer: TOP5CallersName,
    },
    {
        field: 'TOP5VisitedName', 
        headerName: 'Name', 
        resizable: true,
        width: 220,
        headerClass: 'i-icon',
        valueGetter: (params) => params.data.Name,
        headerTooltip: 'The name of the cryptocurrency caller being called last.',
        flex: 1,
        cellRenderer: TOP5TokensAndVisitedName,
    },
    {
        field: 'BuyLinkTop5', 
        headerName: '', 
        resizable: true, 
        width: 113,
        enableCellTextSelection: true,
        headerClass: 'i-icon',
        headerTooltip: 'A link to a platform where users can purchase the mentioned token.',
        cellRenderer: BuyLinkHtml,
    },
    {
        field: 'AVG_CallImmediateEffect', 
        headerName: 'CALL EFC', 
        resizable: true, 
        width: 85,
        headerClass: 'i-icon',
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        headerTooltip: 'Maximal positive  market capitalization change  of the token in the first 15 minutes after the call was made.' ,
        comparator: customSort,
        cellRenderer: RedOrGreenColoringCallEf,
    },
    {
        field: 'Top5_Callers_AVG_CallImmediateEffect', 
        headerName: 'CALL EFC', 
        resizable: true, 
        width: 110,
        headerClass: 'i-icon',
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        headerTooltip: 'Maximal positive  market capitalization change  of the token in the first 15 minutes after the call was made.' ,
        valueGetter: (params) => params.data.AVG_CallImmediateEffect,
        comparator: customSort,
        cellRenderer: RedOrGreenColoringCallEf,
    },
    {
        field: 'AVG_FromCallToPeak', 
        headerName: 'Peak', 
        resizable: true, 
        width: 85,
        headerClass: 'i-icon',
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        headerTooltip: "The percentage change in price from the time of the call to the token's all-time high (ATH).",
        valueGetter: (params) => params.data.AVG_FromCallToPeak,
        comparator: customSort,
        cellRenderer: RedOrGreenColoringPeak
    },
    {
        field: 'AVG_TracingImpact', 
        headerName: 'Trace', 
        resizable: true, 
        width: 85,
        headerClass: 'i-icon',
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        headerTooltip: "An ongoing assessment of the token's market capitalization movement and impact since the call.",
        comparator: customSort,
        cellRenderer: RedOrGreenColoringHtml,
    },
    {
        field: 'Top5AVG_TracingImpact', 
        headerName: 'Trace', 
        resizable: true, 
        width: 100,
        headerClass: 'i-icon',
        tooltipValueGetter: (p) => p.colDef.headerTooltip,
        headerTooltip: "An ongoing assessment of the token's market capitalization movement and impact since the call.",
        valueGetter: (params) => params.data.AVG_TracingImpact,
        comparator: customSort,
        cellRenderer: RedOrGreenColoringHtml,
    }
]